import { Language } from '../i18n/translations'

/**
 * Get localized name - returns Arabic if language is Arabic and Arabic value exists, otherwise returns English
 */
export function getLocalizedName(
  name: string,
  nameAr: string | null | undefined,
  language: Language
): string {
  if (language === 'ar' && nameAr) {
    return nameAr
  }
  return name
}

/**
 * Get localized description - returns Arabic if language is Arabic and Arabic value exists, otherwise returns English
 */
export function getLocalizedDescription(
  description: string | null | undefined,
  descriptionAr: string | null | undefined,
  language: Language
): string {
  if (language === 'ar' && descriptionAr) {
    return descriptionAr
  }
  return description || ''
}


